<template>
  <div>
    <el-dialog
      :title="currentStep === 1 ? $t('components.DialogQuickAddMachine.586649-0') : $t('components.DialogQuickAddMachine.586649-16')"
      :visible.sync="dialogQuickAddMachine"
      :width="currentStep === 1 ? '500px' : '700px'"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="cancelQuickAddMachine"
    >
      <!-- 第一步：快捷添加表单 -->
      <div v-if="currentStep === 1">
        <el-form :model="form" :rules="rules" ref="quickAddForm">
          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-1')" prop="prefix" required>
            <el-input
              v-model="form.prefix"
              :placeholder="$t('components.DialogQuickAddMachine.586649-2')"
              maxlength="20"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-3')" prop="padding" required>
            <el-input
              v-model="form.padding"
              :placeholder="paddingPlaceholder"
              type="number"
              min="1"
              max="10"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-4')" prop="count" required>
            <el-input
              v-model="form.count"
              :placeholder="$t('components.DialogQuickAddMachine.378452-0')"
              type="number"
              min="1"
              max="1000"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-19')" prop="equipmentName" required>
            <el-input
              v-model="form.equipmentName"
              :placeholder="$t('components.DialogQuickAddMachine.121041-0')"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-8')" prop="typeId" required>
            <el-select
              v-model="form.typeId"
              filterable
              :placeholder="$t('components.DialogQuickAddMachine.586649-9')"
              style="width: 100%"
            >
              <el-option v-for="item in machineType" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-10')" prop="teamId" required>
            <el-select
              v-model="form.teamId"
              filterable
              :placeholder="$t('components.DialogQuickAddMachine.586649-11')"
              style="width: 100%"
            >
              <el-option>
                <div
                  @click="openCreateGroupDialog"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: var(--vtm-ink-2);
                    font-weight: normal;
                  "
                >
                  {{ $t("machineGroup.add") }}
                  <span class="el-icon-plus" style="float: right; color: var(--vtm-mint-ink)">{{ $t("common.add") }}</span>
                </div>
              </el-option>
              <el-option
                v-for="item in machineGroupOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-12')">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.notes"
              :placeholder="$t('components.DialogQuickAddMachine.586649-13')"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelQuickAddMachine">{{ $t("components.DialogQuickAddMachine.586649-14") }}</el-button>
          <el-button type="primary" @click="submitFirstStep">{{
            $t("components.DialogQuickAddMachine.586649-15")
          }}</el-button>
        </div>
      </div>

      <!-- 第二步：确认添加或转移 -->
      <div v-else>
        <el-form label-width="100px">
          <el-form-item :label="$t('components.DialogQuickAddMachine.586649-17')">
            <el-select
              v-model="transferAccount"
              :no-data-text="$t('common.noData')"
              :no-match-text="$t('common.noData')"
              filterable
              remote
              clearable
              :remote-method="remoteMethod"
              :loading="loadingUser"
              :placeholder="$t('components.DialogQuickAddMachine.586649-18')"
              style="width: 300px"
            >
              <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id">
                <span style="float: left">{{ item.userName }}</span>
                <span style="float: right; color: var(--vtm-ink-2); font-size: 13px">{{ item.nickName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <el-table :data="generatedDevices" style="width: 100%; margin-top: 20px" border max-height="400px">
          <el-table-column
            prop="typeName"
            :label="$t('components.DialogQuickAddMachine.586649-8')"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="equipmentName"
            :label="$t('components.DialogQuickAddMachine.586649-19')"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="equipmentNo"
            :label="$t('components.DialogQuickAddMachine.586649-20')"
            align="center"
          ></el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="goBackToFirstStep">{{ $t("components.DialogQuickAddMachine.586649-21") }}</el-button>
          <el-button :loading="loading" type="primary" @click="confirmAdd">{{
            $t("components.DialogQuickAddMachine.586649-22")
          }}</el-button>
          <el-button :loading="loading" type="success" @click="confirmTransfer"
            >{{ $t("components.DialogQuickAddMachine.586649-23") }}{{ generatedDevices.length
            }}{{ $t("components.DialogQuickAddMachine.586649-24") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <add-machine-group-dialog :visible.sync="showAddGroupDialog" @success="handleAddGroupSuccess" />
  </div>
</template>

<script>
  import AddMachineGroupDialog from "./AddMachineGroupDialog";
  export default {
    name: "DialogQuickAddMachine",
    props: {
      dialogQuickAddMachine: {
        type: Boolean,
        default: false
      },
      machineType: {
        type: Array,
        default: () => []
      },
      machineGroup: {
        type: Array,
        default: () => []
      }
    },
    components: {
      AddMachineGroupDialog
    },
    data() {
      return {
        currentStep: 1, // 当前步骤：1-快捷添加表单，2-确认添加或转移

        // 第一步表单数据
        form: {
          prefix: "",
          padding: "",
          count: "",
          equipmentName: "",
          typeId: "",
          teamId: "",
          notes: ""
        },

        // 表单验证规则
        rules: {
          prefix: [
            { required: true, message: this.$t("components.DialogQuickAddMachine.586649-25"), trigger: "blur" },
            { validator: this.validatePrefix, trigger: "blur" }
          ],
          padding: [
            { required: true, message: this.$t("components.DialogQuickAddMachine.586649-26"), trigger: "blur" },
            { validator: this.validatePadding, trigger: "blur" }
          ],
          count: [
            { required: true, message: this.$t("components.DialogQuickAddMachine.586649-27"), trigger: "blur" },
            {
              type: "number",
              min: 1,
              max: 1000,
              message: this.$t("components.DialogQuickAddMachine.378452-1"),
              trigger: "blur",
              transform: value => Number(value)
            }
          ],
          equipmentName: [
            { required: true, message: this.$t("components.DialogQuickAddMachine.586649-7"), trigger: "blur" }
          ],
          typeId: [
            { required: true, message: this.$t("components.DialogQuickAddMachine.586649-9"), trigger: "change" }
          ],
          teamId: [
            { required: true, message: this.$t("components.DialogQuickAddMachine.586649-11"), trigger: "change" }
          ]
        },

        // 第二步数据
        transferAccount: "",
        generatedDevices: [], // 生成的设备列表
        loading: false,
        userList: [], // 用户列表
        loadingUser: false, // 用户搜索加载状态
        // 新建分组弹窗
        showAddGroupDialog: false,
        // 设备分组选项（本地可变副本）
        machineGroupOptions: []
      };
    },
    computed: {
      // 动态补位数提示文本
      paddingPlaceholder() {
        const count = parseInt(this.form.count);
        const prefixLength = this.form.prefix ? this.form.prefix.length : 0;

        let minPadding = 1;
        let tips = [];

        // 根据创建台数确定最小补位数
        if (count > 0) {
          minPadding = Math.max(minPadding, count.toString().length);
          tips.push(this.$t("components.DialogQuickAddMachine.586649-29", [count, count.toString().length]));
        }

        // 根据设备号总长度确定最小补位数
        if (prefixLength > 0) {
          const minPaddingForTotal = Math.max(1, 10 - prefixLength);
          minPadding = Math.max(minPadding, minPaddingForTotal);
          tips.push(this.$t("components.DialogQuickAddMachine.586649-30", [prefixLength]));
        }

        let placeholder = this.$t("components.DialogQuickAddMachine.586649-31", [minPadding]);
        if (tips.length > 0) {
          placeholder += `（${tips.join("，")}）`;
        }

        return placeholder;
      }
    },
    watch: {
      dialogQuickAddMachine(val) {
        if (val) {
          this.currentStep = 1;
          this.resetForm();
        }
      },
      // 同步父级传入的分组列表到本地可编辑副本
      machineGroup: {
        immediate: true,
        deep: true,
        handler(val) {
          this.machineGroupOptions = Array.isArray(val) ? [...val] : [];
        }
      },

      // 监听创建台数变化，重新验证补位数
      "form.count"() {
        if (this.$refs.quickAddForm && this.form.padding) {
          this.$nextTick(() => {
            this.$refs.quickAddForm.validateField("padding");
          });
        }
      },

      // 监听前缀变化，重新验证补位数
      "form.prefix"() {
        if (this.$refs.quickAddForm && this.form.padding) {
          this.$nextTick(() => {
            this.$refs.quickAddForm.validateField("padding");
          });
        }
      },

      // 监听补位数变化，重新验证前缀
      "form.padding"() {
        if (this.$refs.quickAddForm && this.form.prefix) {
          this.$nextTick(() => {
            this.$refs.quickAddForm.validateField("prefix");
          });
        }
      }
    },
    mounted() {
      console.log(this.$t("components.DialogQuickAddMachine.586649-32"));
    },
    methods: {
      // 验证前缀
      validatePrefix(rule, value, callback) {
        if (!value) {
          callback(new Error(this.$t("components.DialogQuickAddMachine.586649-25")));
          return;
        }

        // 验证设备号总长度
        const prefixLength = value.length;
        const padding = parseInt(this.form.padding);

        if (padding > 0) {
          const totalLength = prefixLength + padding;
          if (totalLength < 10) {
            callback(
              new Error(this.$t("components.DialogQuickAddMachine.586649-33", [prefixLength, padding, totalLength]))
            );
            return;
          }
        }

        callback();
      },

      // 验证补位数
      validatePadding(rule, value, callback) {
        if (!value) {
          callback(new Error(this.$t("components.DialogQuickAddMachine.586649-26")));
          return;
        }

        const padding = parseInt(value);
        const count = parseInt(this.form.count);

        if (isNaN(padding) || padding < 1 || padding > 10) {
          callback(new Error(this.$t("components.DialogQuickAddMachine.586649-34")));
          return;
        }

        if (count > 0) {
          const minPadding = count.toString().length;
          if (padding < minPadding) {
            callback(new Error(this.$t("components.DialogQuickAddMachine.586649-35", [count, minPadding])));
            return;
          }
        }

        // 验证设备号总长度
        const prefixLength = this.form.prefix ? this.form.prefix.length : 0;
        const totalLength = prefixLength + padding;
        if (totalLength < 10) {
          callback(
            new Error(this.$t("components.DialogQuickAddMachine.586649-33", [prefixLength, padding, totalLength]))
          );
          return;
        }

        callback();
      },

      // 重置表单
      resetForm() {
        this.form = {
          prefix: "",
          padding: "",
          count: "",
          equipmentName: "",
          typeId: "",
          teamId: "",
          notes: ""
        };
        this.transferAccount = "";
        this.generatedDevices = [];
        this.userList = [];
        if (this.$refs.quickAddForm) {
          this.$refs.quickAddForm.clearValidate();
        }
      },

      // 提交第一步表单
      submitFirstStep() {
        this.$refs.quickAddForm.validate(valid => {
          if (valid) {
            this.generateDeviceList();
            this.currentStep = 2;
          } else {
            this.$message.error(this.$t("components.DialogQuickAddMachine.586649-36"));
            return false;
          }
        });
      },

      // 根据表单数据生成设备列表
      generateDeviceList() {
        const devices = [];
        const count = parseInt(this.form.count);
        const padding = parseInt(this.form.padding);

        for (let i = 1; i <= count; i++) {
          const equipmentNo = this.form.prefix + i.toString().padStart(padding, "0");
          const equipmentName = this.form.equipmentName;

          devices.push({
            typeName: this.getDeviceTypeLabel(this.form.typeId),
            equipmentName: equipmentName,
            equipmentNo: equipmentNo
          });
        }

        this.generatedDevices = devices;
      },

      // 获取设备类型显示文本
      getDeviceTypeLabel(typeId) {
        const typeItem = this.machineType.find(item => item.id === typeId);
        return typeItem ? typeItem.name : "";
      },

      // 确认添加
      confirmAdd() {
        this.callQuickAddMachineApi();
      },

      // 确认转移
      confirmTransfer() {
        if (!this.transferAccount) {
          this.$message.warning(this.$t("components.DialogQuickAddMachine.586649-37"));
          return;
        }
        this.callQuickAddMachineApi(this.transferAccount);
      },

      // 调用快捷添加设备接口
      callQuickAddMachineApi(userId = null) {
        const requestData = {
          typeId: this.form.typeId,
          teamId: this.form.teamId,
          equipmentNo: this.form.prefix,
          notes: this.form.notes,
          equipments: this.generatedDevices.map(device => ({
            equipmentName: device.equipmentName,
            equipmentNo: device.equipmentNo
          }))
        };

        // 如果有转移用户ID，则添加到请求参数中
        if (userId) {
          requestData.userId = userId;
        }
        this.loading = true;
        this.$api
          .request(this.$url.Machine.insertBatch, this.$method.post, requestData)
          .then(res => {
            if (res.code === 0) {
              if (userId) {
                this.$message.success(
                  this.$t("components.DialogQuickAddMachine.586649-38", [this.generatedDevices.length])
                );
              } else {
                this.$message.success(this.$t("components.DialogQuickAddMachine.586649-39"));
              }
              this.cancelQuickAddMachine();
              // 可以触发父组件刷新列表
              this.$emit("refresh");
            } else {
              this.$message.error(res.msg || this.$t("components.DialogQuickAddMachine.586649-40"));
            }
          })
          .catch(error => {
            console.error(this.$t("components.DialogQuickAddMachine.586649-41"), error);
            this.$message.error(this.$t("components.DialogQuickAddMachine.586649-42"));
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // 返回上一步
      goBackToFirstStep() {
        this.currentStep = 1;
      },

      // 远程搜索用户
      remoteMethod(query) {
        if (query !== "") {
          this.loadingUser = true;
          this.$api
            .request(this.$url.User.listUserByUsername, this.$method.get, {
              userName: query
            })
            .then(res => {
              if (res.code === 0) {
                this.userList = res.data || [];
              } else {
                this.userList = [];
              }
            })
            .catch(() => {
              this.userList = [];
            })
            .finally(() => {
              this.loadingUser = false;
            });
        } else {
          this.userList = [];
        }
      },

      // 取消操作
      cancelQuickAddMachine() {
        this.currentStep = 1;
        this.resetForm();
        this.$emit("cancel");
      },
      // 打开新建分组弹窗
      openCreateGroupDialog() {
        this.showAddGroupDialog = true;
      },
      // 新建/编辑分组成功回调
      handleAddGroupSuccess(newGroup) {
        const data = newGroup || {};
        // 情况1：后端返回了带 id 的分组，直接插入并选中
        if (data.id) {
          const exists = this.machineGroupOptions.some(g => g.id === data.id);
          if (!exists) {
            this.machineGroupOptions.unshift({ id: data.id, name: data.name });
          }
          this.form.teamId = data.id;
          this.$emit("refreshGroup");
          return;
        }
        // 情况2：未拿到 id，主动刷新分组列表再根据名称回填
        const createdName = data.name;
        this.$api
          .request(this.$url.MachineGroup.list, this.$method.get)
          .then(res => {
            if (res.code === 0) {
              this.machineGroupOptions = Array.isArray(res.data) ? res.data : [];
              if (createdName) {
                const found = this.machineGroupOptions.find(item => item.name === createdName);
                if (found && found.id) {
                  this.form.teamId = found.id;
                }
              }
            }
          })
          .finally(() => {
            this.$emit("refreshGroup");
          });
      }
    }
  };
</script>

<style scoped>
  .dialog-footer {
    text-align: right;
  }

  .el-table {
    margin-top: 20px;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  /* 表格样式优化 */
  .el-table th {
    background-color: var(--vtm-surface-2);
    color: var(--vtm-ink-2);
    font-weight: 500;
  }

  .el-table td {
    color: var(--vtm-ink-2);
  }

  /* 按钮样式调整 */
  .dialog-footer .el-button {
    margin-left: 10px;
  }

  /* 转移账号选择器样式 */
  .el-select .el-option .el-option__first-line {
    font-weight: 500;
    color: var(--vtm-ink);
  }

  .el-select .el-option .el-option__second-line {
    color: var(--vtm-ink-2);
    font-size: 13px;
  }
</style>
